// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "tr.api-saving[data-v-36e300cf]{opacity:.8}tr.is-unsaved[data-v-36e300cf]{background-color:rgba(24,118,210,.15)}tr.is-unsaved[data-v-36e300cf]:hover{background-color:rgba(24,118,210,.2)!important}tr.full-row-click[data-v-36e300cf]{cursor:pointer}tr.api-saved[data-v-36e300cf]{background-color:rgba(37,239,0,.09)}.handle[data-v-36e300cf]{cursor:pointer}.expansion-container[data-v-36e300cf]{padding:0!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
